import React, { Fragment, useEffect, useState } from 'react';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from '@headlessui/react';
import {
  ChevronDownIcon,
  Bars3Icon,
  BellIcon,
} from '@heroicons/react/20/solid';
import { useDispatch } from 'react-redux';
import { logout } from '../../actions/auth';
import { connect, disconnect } from '../../actions/wallet';
import { Link, useNavigate } from 'react-router-dom';
import BlockchainService from '../../services/blockchain.service';
import AccountSettingsService from '../../services/account-settings.service';
import { Spinner, Alert } from '../../services/notiflix.service';
import configService from '../../services/config.service';
import { useSelector } from 'react-redux';
import ChangePassword from '../common/ChangePassword';
import { AssetbloxLogoWhiteSvgIcon } from '../common/IconProvider';
import ImageLoader from '../common/ImageLoader';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../actions/langauge';
import { setBankTransfer } from '../../actions/bankTransfer';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const Header = () => {
  const { wallet } = useSelector((state) => state.wallet);
  const { user: _authUser } = useSelector((state) => state.auth);
  const { pendingTransactions } = useSelector(
    (state) => state.bankTransferReducer,
  );
  const [isChangePasswordPop, setChangePasswordPop] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isConnectWallet, setConnectWallet] = useState(
    wallet?.walletAddress ? wallet?.walletAddress : null,
  );
  const [userData, setUserData] = useState(false);
  const [isAddedWallet, setIsaddedWallet] = useState(false);

  const { t } = useTranslation(['projectDetails', 'header', 'common']);

  const logOut = async () => {
    dispatch(logout());
    dispatch(disconnect());
    navigate('/login');
  };

  const walletDisconnect = () => {
    dispatch(disconnect());
    setConnectWallet(null);
    setUserData(true);
  };
  useEffect(() => {
    if (_authUser?.user_wallets && _authUser?.user_wallets?.length > 0) {
      setIsaddedWallet(true);
    }
  }, []);

  useEffect(() => {
    userDetails();
  }, [userData]);

  const userDetails = async () => {
    let _resp = await AccountSettingsService.details();
    Spinner.hide();
    if (_resp.status === 'failure') {
      Alert.error(_resp.message);
      return false;
    }

    if (_resp?.data?.userWallets?.length > 0) {
      setIsaddedWallet(true);
    }
  };

  const connectWallet = async () => {
    try {
      if (isConnectWallet) {
        return false;
      }
      Spinner.show();
      let _walletResp = await BlockchainService.connectWallet();
      if (_walletResp.status === 'failure') {
        Spinner.hide();
        Alert.error(_walletResp.message);
        return false;
      }

      Spinner.hide();
      let _formData = {
        walletAddress: _walletResp.data.walletAddress,
      };
      setConnectWallet(_walletResp.data.walletAddress);

      dispatch(connect(_formData));
      setUserData(true);
      const wallets = {
        wallet_address: _walletResp.data.walletAddress,
        is_whitelisted: 0,
      };

      let _res = await AccountSettingsService.addUserWallets(wallets);

      if (_res.status === 'failure') {
        Spinner.hide();
        Alert.error(_res.message);
        dispatch(disconnect());
        setConnectWallet(null);
        return false;
      }
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };
  if (window.ethereum) {
    window.ethereum.on('accountsChanged', handleAccountsChanged);
  }

  async function handleAccountsChanged(accounts) {
    if (accounts?.length === 0) {
      dispatch(disconnect());
      setConnectWallet(null);
    } else {
      // Metamask account has changed
      let _formData = {
        walletAddress: accounts[0],
      };
      dispatch(connect(_formData));
      connectWallet();
      setUserData(true);
      // Do something here to handle the account change event
    }
  }

  const _sideBarOpen = () => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('sideOpen', {
          detail: true,
        }),
      );
    }
  };
  const { i18n } = useTranslation();

  const language = useSelector((state) => state.languageReducer.language);

  // // Sync i18n with Redux state
  useEffect(() => {
    i18n.changeLanguage(language); // Sync i18n with Redux language
  }, [language]);

  // Handle language change from dropdown
  const handleLanguageChange = async (lng) => {
    try {
      let langUpdateResponse = await AccountSettingsService.updateUserLocalLang(
        {
          lang: lng,
        },
      );

      if (langUpdateResponse.status === 'failure') {
        Alert.error(langUpdateResponse.message);
      }

      const selectedLanguage = lng;
      i18n.changeLanguage(selectedLanguage);
      dispatch(changeLanguage(selectedLanguage));
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };

  const handleTransactionSelect = (transaction) => {
    dispatch(setBankTransfer(transaction));
    navigate(`/assets/details/${transaction.project_id}`, {
      state: {
        openPaymentDetailsModal: true,
      },
    });
  };
  return (
    <>
      <div className="sticky top-0 md:pt-4 md:mx-0 -mx-4  z-30 bg-white dark:bg-slate-900">
        <div>
          <span className="bg-[#A7D760]"></span>
          <span className="bg-[#3D4CB2]"></span>
          <span className="bg-[#9F9787]"></span>
          <span className="bg-[#E79853]"></span>
          <span className="bg-[#113B69]"></span>
        </div>
        <div className="bg-brandBlue p-3 md:rounded-lg mb-4 ">
          <div className="flex items-center justify-between">
            <div className="bg-transparent">
              <Link to={'/'}>
                <AssetbloxLogoWhiteSvgIcon />
              </Link>
              <div className="w-11 h-11 rounded-full flex items-center justify-center bg-white bg-opacity-5 md:hidden cursor-pointer">
                <Bars3Icon
                  onClick={() => _sideBarOpen()}
                  className="h-5 w-5 text-white "
                  aria-hidden="true"
                />
              </div>
            </div>

            <div className="inline-flex items-center">
              {pendingTransactions.length > 0 ? (
                <Menu as="div" className="relative inline-block text-left">
                  <MenuButton className="inline-flex items-center gap-x-1.5 border-2 border-gray-300 rounded-md bg-transparent px-3 py-2 mx-4 text-sm font-semibold text-white">
                    <BellIcon
                      className="h-5 w-5 text-white"
                      aria-hidden="true"
                    />
                    <span className="text-[#F59342]">
                      {t('projectDetails:awaiting_funds')}
                    </span>
                    <ChevronDownIcon
                      className="h-5 w-5 text-white"
                      aria-hidden="true"
                    />
                  </MenuButton>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <MenuItems className="absolute left-4 z-10 mt-2 w-64 origin-top-right rounded-md bg-white  ring-black ring-opacity-5 focus:outline-none">
                      {pendingTransactions.map((transaction) => (
                        <MenuItem key={transaction.order_id}>
                          {({ active }) => (
                            <div
                              onClick={() =>
                                handleTransactionSelect(transaction)
                              }
                              className={classNames(
                                active
                                  ? 'bg-gray-100 text-brandBlue rounded-md'
                                  : 'text-black',
                                'cursor-pointer flex gap-2 items-center p-2',
                              )}
                            >
                              <p className="font-semibold truncate max-w-[120px] overflow-hidden whitespace-nowrap text-ellipsis">
                                {transaction.projectName || 'N/A'}
                              </p>
                              <span>•</span>
                              <p>{transaction.expiryDate || 'N/A'}</p>
                            </div>
                          )}
                        </MenuItem>
                      ))}
                    </MenuItems>
                  </Transition>
                </Menu>
              ) : (
                <WalletMenu
                  wallet={wallet}
                  isAddedWallet={isAddedWallet}
                  configService={configService}
                  connectWallet={connectWallet}
                  walletDisconnect={walletDisconnect}
                />
              )}
              <div className="inline-flex items-center bg-white p-1 rounded-md">
                <button
                  onClick={() => handleLanguageChange('en')}
                  className={
                    language === 'en'
                      ? 'active py-2 px-3 bg-GreenColor'
                      : 'py-2 px-3'
                  }
                >
                  EN
                </button>
                <button
                  onClick={() => handleLanguageChange('nl')}
                  className={
                    language === 'nl'
                      ? 'active py-2 px-3 bg-GreenColor'
                      : 'py-2 px-3'
                  }
                >
                  NL
                </button>
              </div>
              <ProfileMenu
                _authUser={_authUser}
                classNames={classNames}
                logOut={logOut}
              />
            </div>
          </div>
        </div>
      </div>
      {isChangePasswordPop ? (
        <ChangePassword setChangePasswordPop={setChangePasswordPop} />
      ) : null}
    </>
  );
};

export const WalletMenu = ({
  wallet,
  isAddedWallet,
  configService,
  connectWallet,
  walletDisconnect,
}) => {
  const { t } = useTranslation(['header', 'common']);
  return (
    <>
      <Menu as="div" className="relative inline-block text-left">
        {(wallet != null || isAddedWallet === true) && (
          <MenuButton className="inline-flex w-full justify-center items-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-900">
            <div
              onClick={() => connectWallet()}
              className="btn-white-outline cursor-pointer"
            >
              {wallet
                ? configService
                    .shortenAddress(wallet?.walletAddress)
                    .toUpperCase()
                : t('common:connect_wallet')}
            </div>
            {wallet ? (
              <ChevronDownIcon
                className="-mr-1 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            ) : (
              ''
            )}
          </MenuButton>
        )}

        {wallet ? (
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <MenuItem className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <div className="px-4 py-2">
                  <button
                    onClick={() => walletDisconnect()}
                    className="bg-white text-brandRed w-full border border-brandRed px-4 py-3"
                  >
                    {t('disconnect')}
                  </button>
                </div>
              </div>
            </MenuItem>
          </Transition>
        ) : (
          ''
        )}
      </Menu>
    </>
  );
};

export const ProfileMenu = ({ _authUser, classNames, logOut }) => {
  const { t } = useTranslation('header');
  return (
    <>
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <MenuButton className="inline-flex w-full justify-center items-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-900  ">
            <div className="w-11 h-11 rounded-full overflow-hidden ">
              <ImageLoader
                src={
                  _authUser.profilePicture
                    ? _authUser.profilePicture
                    : '/img/default-user-icon.png'
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/img/default-user-icon.png';
                }}
                className="w-full h-full"
                alt={configService.appName() + ' Logo'}
              />
            </div>
            <ChevronDownIcon
              className="-mr-1 h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </MenuButton>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1">
              <MenuItem>
                {({ active }) => (
                  <Link
                    to="/profile"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm',
                    )}
                  >
                    {t('account_settings')}
                  </Link>
                )}
              </MenuItem>

              <MenuItem>
                {({ active }) => (
                  <button
                    type="submit"
                    onClick={() => logOut()}
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block w-full px-4 py-2 text-left text-sm',
                    )}
                  >
                    {t('sign_out')}
                  </button>
                )}
              </MenuItem>
            </div>
          </MenuItems>
        </Transition>
      </Menu>
    </>
  );
};

export default Header;
